if (!window.customElements.get('geolocation-popup')) {
  class GeolocationPopup extends HTMLElement {
    constructor() {
      super();
      this.closeButton = this.querySelector('[data-geolocation-popup-close]');
      this.links = this.querySelectorAll('[data-geolocation-popup-link]');
      this.userHasSelectedDomain = window.localStorage.getItem('userSelectedDomain');
      this.userCountry = window.localStorage.getItem('userCountry');
    }

    connectedCallback () {
      this.closeButton.addEventListener('click', () => this.closePopup().bind(this));
      this.links.forEach((link) => link.addEventListener('click', () => this.goToLink(link).bind(this)));

      // If no user country, get country
      if (!this.userCountry) {
        this.checkGeoLocation();
      // If user country but no selected domain, trigger popup for user to choose domain
      } else if (!this.userHasSelectedDomain) {
        if (this.userCountry === 'US' && window.location.href.indexOf('.ca') >= 0) {
          this.openPopup();
        } else if (this.userCountry === 'CA' && window.location.href.indexOf('.com') >= 0) {
          this.openPopup();
        }
      // If user country and selected domain but the current domain does not match the selected domain, trigger popup
      } else if (this.userCountry && this.userHasSelectedDomain) {
        const domainExtension = this.userHasSelectedDomain.indexOf('.ca') >= 0 ? '.ca' : '.com';

        if (window.location.href.indexOf(domainExtension) === -1) {
          this.openPopup();
        }
      }
    }

    disconnectedCallback () {
      this.closeButton.removeEventListener('click', this.closePopup().bind(this));
      this.links.forEach((link) => link.removeEventListener('click', () => this.goToLink().bind(this)));
    }

    async checkGeoLocation() {
      async function getLocationData () {
        try {
          const res = await fetch('/browsing_context_suggestions.json');
          if (!res.ok) { throw new Error(res.statusText); }
          return await res.json();
        } catch (err) {
          console.error(err);
        }
      }

      const data = await getLocationData();

      if (data?.detected_values?.country?.handle) {
        if (data?.detected_values?.country?.handle === 'US' && window.location.href.indexOf('.ca') >= 0) {
          this.openPopup();
        } else if (data?.detected_values?.country?.handle === 'CA' && window.location.href.indexOf('.com') >= 0) {
          this.openPopup();
        }

        window.localStorage.setItem('userCountry', data?.detected_values?.country?.handle);
      }
    }

    closePopup () {
      this.classList.remove('active');
      window.localStorage.setItem('userSelectedDomain', window.location.href);
      window.removeTrapFocus(this);
    }

    openPopup () {
      this.classList.add('active');
      this.closeButton.focus();
      window.trapFocus(this);
    }

    goToLink (link) {
      const linkDestination = link.getAttribute('data-link');
      window.localStorage.setItem('userSelectedDomain', linkDestination);
      window.location.href = linkDestination;
    }
  }

  window.customElements.define('geolocation-popup', GeolocationPopup);
}